module.exports = __webpack_public_path__ + "media/images/athletes/4325-f5813f187dd8ca13733bb6f000c95d5a.png";